/**
 * Shared form styling configuration.
 * Use these styles consistently across all forms for better UX and maintainability.
 */
export const formStyles = {
  panel: { backgroundColor: "#ffffff", color: "#212529" },
  content: { padding: "1rem" },
  label: { color: "#212529", fontWeight: "600" as const },
  input: {
    backgroundColor: "#ffffff",
    color: "#212529",
    padding: "0.75rem 0.75rem",
  },
  error: { color: "#dc3545", display: "block" as const, marginTop: "0.25rem" },
  helper: { color: "#6b7280", display: "block" as const, marginTop: "0.25rem" },
};
